<template>
  <div class="level">
    <van-nav-bar
      :title="$t('m.yh_span0')"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <div class="level_con">
      <div style="margin-bottom:10px;">
        <div style="font-size:18px;color:#000;font-weight:bold;">
          {{ $t("m.yh_span0") }}
        </div>
        <div style="font-size:13px;color:#666;">
          {{ $t("m.yh_span01") }}{{ list.length }}{{ $t("m.yh_span0") }}
        </div>
      </div>
      <div
        v-for="(item, index) in list.slice(0, 1)"
        :key="index"
        style="padding:15px;overflow:hidden;font-weight:bold;background:linear-gradient(to right,#ff6b5a,#ff1900);border-radius:6px;color:#ffffff;margin-bottom:20px"
      >
        <div style="display:flex;justify-content:space-between">
          <van-switch
            v-model="checked"
            size="24px"
            active-color="var(--bg-color)"
            inactive-color="#dcdee0"
          />
          <div>{{ item.type }}</div>
        </div>
        <div style="margin:20px 0;">
          {{ item.card.slice(0,5) }} {{ item.card.slice(5,10) }}
          {{ item.card.slice(10,15) }} {{ item.card.slice(15,19) }}
        </div>
        <div style="display:flex;justify-content:space-between;">
          <div>
            <div style="margin-bottom:5px">{{ $t("m.yh_span1") }}</div>
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
      <list>
        <div
          v-for="(item, index) in list.slice(0, 1)"
          :key="index"
          style="padding:15px;display:flex;border-radius:6px;align-items:center;margin-bottom:15px"
          :style="{
            background:
              index % 3 == 0
                ? 'linear-gradient(to right,#ff6b5a,#ff1900)'
                : index % 3 == 1
                ? '#ff1900'
                : 'linear-gradient(to right,#ff6b5a,#ff1900)'
          }"
        >
          <div
            style="border-radius:50%;background:#fff;width:40px;height:40px;margin-right:15px;display:flex;align-items:center;justify-content:center;"
          >
            <img
              v-if="item.type != '2'"
              src="../../../assets/images/yhk.png"
              style="width:30px;height:30px;"
              alt=""
            />
            <img
              v-else
              src="../../../assets/images/new/USDT.png"
              style="width:30px;height:30px;"
              alt=""
            />
          </div>
          <div style="flex:1;font-size:16px;color:#fff;">
            <div style="font-weight:bold;margin-bottom:8px;">
              {{ item.btype }}
            </div>
            <div>{{ item.card }}</div>
            <div style="margin-top:8px;">{{ $t("m.yh_span02") }}</div>
          </div>
        </div>
      </list>
      <div v-if="list.length===0">
        <div
          @click="$router.push({ name:'bank_add' })"
          style="margin-top:20px;border-radius:30px;line-height:40px;text-align:center;font-size:16px;font-weight:bold;color:#fff;background:#ff1900;"
        >
          + {{ $t("m.yh_span2") }}
        </div>
      </div>
      <div style="height:50px;"></div>
    </div>
  </div>
</template>

<script>
import { getBankList } from "../../../api/public";
import { getUserInfo } from "../../../api/user";
import Icon from "vant/lib/icon";
import vanSwitch from "vant/lib/switch";
import List from "vant/lib/list";
import "vant/lib/switch/style";
import "vant/lib/list/style";

export default {
  name:"index",
  components:{
    Icon,
    vanSwitch,
    List
  },
  data(){
    return {
      show:false,
      checked:true,
      list:[],
      realname:""
    };
  },
  mounted(){
    getBankList({page:1})
      .then(res=>{
        this.list=(res.data.data||[]).slice(0,1);
      })
      .catch(e=>{
        this.$dialog.error(e.response.data.msg);
      });

    let that=this;
    setTimeout(function(){
      getUserInfo()
        .then(res=>{
          if(res.data.data.is_auth===0){
            that.$router.push({name:"memmber_business"});
          }else{
            that.realname=res.data.data.realname;
          }
        })
        .catch(e=>{
          that.$dialog.error(e.response.data.msg);
        });
    },1000);
  },
  methods:{
    onClickLeft(){
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="less">
.tianjia{
  width:100%;
  margin:0 auto;
  height:45px;
  background:linear-gradient(to right,#ff6241,#ff6241,#ff3738);
  border-radius:30px;
  margin-top:40px;
  text-align:center;
  line-height:45px;
  color:#ffffff;
  border:0px solid;
  font-size:15px;
  font-weight:bold;
}
/deep/ .van-nav-bar{
  background:#fff;
}
/deep/ .van-nav-bar .van-icon{
  color:#000;
}
/deep/ .van-nav-bar__title{
  color:#000;
}
.jiangli_top{
  width:100%;
  height:50px;
  background-color:#ffffff;
  position:relative;
}
.jiangli_top i{
  position:absolute;
  top:13px;
  left:16px;
  width:24px;
  height:24px;
  cursor:pointer;
  font-size:24px;
}
.level_con{
  padding:20px 15px;
}
</style>